if (document.body.classList.contains('page-template-page-knowledge')) {
  const href = window.location.href;
  const pageTitle = document.getElementById('pageTitle');
  const linkLivingDonor = document.querySelector('li.link-living-donor a');

  if (linkLivingDonor) {
    linkLivingDonor.addEventListener('click', (e) => {
      e.preventDefault();
      const link = e.target.href;
      location.replace(link)
      location.reload();
      return false;
    });
  }

  if (href.indexOf("baza-wiedzy") > 0) {
  const hashFilter = href.split("#")[1];
  if (hashFilter !== undefined && hashFilter !== "") {
    if (hashFilter === 'dawca') {
      pageTitle.textContent = 'Żywy dawca';
      document.body.classList.add('page-living-donor-filtered');
    } else {
      pageTitle.innerHTML = 'Twoja <span class="purple">Baza wiedzy</span>';
      document.body.classList.remove('page-living-donor-filtered');
    }

    const hashFilterSplit = hashFilter.split('page-');
    const hashes = hashFilterSplit[0] ? hashFilterSplit[0].split(',') : [];
    const page = hashFilterSplit[1] || 1;
    hashes.forEach(hash => {
      if(hash !== ''){
        $(`.filters .check-filters input[type=checkbox][data-name=${hash}]`).prop("checked", true);
      }
    });
    const categories = [];
    $('.filters .check-filters input[type=checkbox]:checked').each(function(){
      categories.push($(this).val());
    })

    function hashesTags() {
      hashes.forEach(hash => {
        $(`.filters .tags a[href='#${hash}']`).addClass('active');
      });
      const tags = [];
      $('.filters .tags a.active').each(function(){
        tags.push($(this).attr('tag-id'));
      })

      $('li.link-living-donor.current-menu-item').each(function() {
        tags.push(22);
      });
    
      displayPosts(page, categories.join(','), tags.join(','));
    }

    if(categories.length > 0) {
      tags(categories, hashesTags);
    }else{
      hashesTags();
    }


  } else {
    displayPosts();
  }
}

$(".filters input:checkbox").on("change", function () {
  const filters = [];
  const categories = [];
  $(".filters input:checkbox").each(function () {
    if ($(this).is(":checked")) {
      filters.push($(this).val());
      if(categories.indexOf($(this).data('name')) === -1) {
        categories.push($(this).data('name'));
      }
    }
  });
  tags(filters);
  displayLoader();
  displayPosts(1, filters.toString());
  window.location.hash = categories.join(',');
});

function getTags(){
  const tags = [];
  $(".filters .tags a").each(function () {
    if ($(this).hasClass("active")) {
      tags.push($(this).data("tag-id"));
    }
  });
  return tags.toString()
}

function getCategories(){
  const categories = [];
  $(".filters input:checkbox").each(function () {
    if ($(this).is(":checked")) {
      categories.push($(this).val());
    }
  });
  return categories.toString()
}

$("body").on("click", ".filters .tags a", function (e) {
  e.preventDefault();

  if (!$(this).hasClass("active")) {
    $(this).addClass("active");
  } else {
    $(this).removeClass("active");
  }
  const tags = getTags();
  const categories = getCategories();

  displayLoader();
  displayPosts(1, categories, tags);

  const href = window.location.href;
  const hashFilter = href.split("#")[1];
  console.log(hashFilter);

  if (hashFilter === 'dawca') {
    pageTitle.textContent = 'Żywy dawca';
    document.body.classList.add('page-living-donor-filtered');
  } else {
    pageTitle.innerHTML = 'Twoja <span class="purple">Baza wiedzy</span>';
    document.body.classList.remove('page-living-donor-filtered');
  }
});

$("body").on(
  "click",
  ".pagination__pages button, .pagination__controls button",
  function () {
    const page = $(this).data("page");
    const tags = getTags();
    const categories = getCategories();
    displayLoader();
    displayPosts(page, categories, tags);
  }
);

$("#clean-category").on("click", function () {
  $(".filters input:checkbox").each(function () {
    $(this).prop("checked", false);
  });
  $(".filters .tags a").each(function () {
    $(this).removeClass("active");
  });
  displayLoader();
  displayPosts();
});

$("#clean-types").on("click", function () {
  $(".filters .types input:checkbox").each(function () {
    $(this).prop("checked", false);
  });
  displayLoader();
  displayPosts();
});

$("#clean-tags").on("click", function () {
  $(".filters .tags a").each(function () {
    $(this).removeClass("active");
  });

  const categories = getCategories();

  displayLoader();
  displayPosts(1, categories);
});

function changeUrl(page){
  let filters = [];
  $('.filters .categories input[type=checkbox]:checked, .filters .types input[type=checkbox]:checked').each(function (){
    if(filters.indexOf($(this).data('name')) === -1) {
      filters.push($(this).data('name'));
    }
  })
  $('.filters .tags a.active').each(function (){
    filters.push($(this).attr('href').substr(1))
  })

  if(page > 1){
    filters.push(`page-${page}`)
  }
  if(filters.length > 0) {
    window.history.pushState("", "", `/baza-wiedzy/#${filters.join(',')}`);
  }else {
    window.history.pushState("", "", '/baza-wiedzy/');
  }
}

var xhr = null;
function displayPosts(page, cat, tag) {
  let params = {};
  params._embed = true;
  params.page = page || 1;
  params.per_page = 9;
  if(cat) {
    params.categories = cat;
  }
  params.order = "desc";
  if(tag) {
    params.tags = tag;
  }

  changeUrl(page);

  if (xhr) {
    xhr.abort();
  }
  xhr = $.get(
    "/wp-json/wp/v2/posts",
    params,
    function (response, textStatus, jqXHR) {
      xhr = null;
      let totalPages = jqXHR.getResponseHeader("X-WP-TotalPages");
      let items = [];
      if (response.length > 0) {
        let posts = [];

        if (Array.from(response).find(post => post['sticky'] === true)) {
          response.forEach((post) => {
            posts.push(post);
            if (post['sticky'] === true) {
              posts.splice(posts.indexOf(post), 1);
              posts.unshift(post);
            }
          });
          posts.forEach((post) => {
            items += item(post);
          })
        } else {
          response.forEach((post) => {
            items += item(post);
          });
        }
        
        $("#knowledge-posts").html(items);
        if (totalPages > 1) {
          $("#knowledge-pagination").html(pagination(totalPages, params.page));
        } else {
          $("#knowledge-pagination").html("");
        }
      } else {
        $("#knowledge-posts").html("<p>Brak wpis�w</p>");
        $("#knowledge-pagination").html("");
      }
    },
    "json"
  );
}

function tags(categories, cb) {
  let param = [];
  categories.forEach((cat) => {
    param.push(`category[]=${cat}`);
  });
  const query = param.join("&");
  let tag = "";
  $.get(`/wp-json/terms/tags?${query}`, function (data) {
    data.post_tag.forEach((t) => {
      tag += `<li><a data-tag-id="${t.term_id}" href="#${t.slug}">${t.name}</a></li>`;
    });
    $("#knowledge-tags").html(tag);
    if(cb){
      cb();
    }
  });
  
}

function item(data) {
  const time =
    data.acf.time < 60
      ? `${data.acf.time} min`
      : `${data.acf.time / 60} h ${data.acf.time % 60} min`;
  let tags = [];
  data._embedded["wp:term"][1].forEach((tag, i) => {
    if (i < 3) {
      let li = `<li><a href="${window.location.hostname}/baza-wiedzy/#${tag.slug}">#${tag.name}</a></li>`;
      tags += li;
    }
  });

  return `
  <div class="col-12 col-md-6 col-xl-4">
    <div class="recommend ${data.acf.video ? "recommend--video" : ""}">
      <div class="recommend__graphics">
        ${
          data.acf.video
            ? '<img src="/app/themes/biorcyzycia/images/play.png" alt="">'
            : data.acf.podcast ? '<img src="/app/themes/biorcyzycia/images/podcast.png" alt="">'
            : ''
        }
        <a href="${data.link}" class="recommend__bg" style="background-image: url(${
          data._embedded["wp:featuredmedia"] !== undefined ? data._embedded["wp:featuredmedia"][0].source_url : '/app/themes/biorcyzycia/images/bw_default_img.jpg'
        });"></a>
        ${ data._embedded["wp:term"][0].filter(term => (term.slug !== 'podcast' && term.slug !=='video')).map( term => (
           `<a href="${window.location.hostname}/baza-wiedzy/#${term.slug}"><span>${term.name}</span></a>`)).join('')
        }
      </div>
      <div class="date-info mb-3">
        <span class="date">${
          data.acf.date
        }</span><span class="time">${time}</span>
      </div>
      <h4><a href="${data.link}">${data.title.rendered}</a></h4>
      <ul class="hashtags">${tags}</ul>
    </div>
  </div>`;
}

function pagination(pages, active) {
  let pagination = "";
  if (pages <= 4) {
    for (let i = 1; i <= pages; i++) {
      pagination += `
          <li><button ${i == active ? 'class="active"' : ""} data-page="${i}">${
        i > 9 ? i : "0" + i
      }</button></li>`;
    }
  } else if (pages > 4 && active < 3) {
    for (let i = 1; i <= pages; i++) {
      if (i < 4) {
        pagination += `
          <li><button ${i == active ? 'class="active"' : ""} data-page="${i}">${
          i > 9 ? i : "0" + i
        }</button></li>`;
      }
    }
    pagination += `<li class="line"></li><li><button data-page="${pages}">${
      pages > 9 ? pages : "0" + pages
    }</button></li>`;
  } else if (active == 3 && pages == 5) {
    pagination = `
      <li><button data-page="1">01</button></li>
      <li class="line"></li>
      <li><button class="active" data-page="${active}">${
      active > 9 ? active : "0" + active
    }</button></li>
      <li><button data-page="${active + 1}">${
      active + 1 > 9 ? active + 1 : "0" + (active + 1)
    }</button></li>
      <li><button data-page="${pages}">${
      pages > 9 ? pages : "0" + pages
    }</button></li>`;
  } else if (active >= 3 && pages - active >= 3) {
    pagination = `
      <li><button data-page="1">01</button></li>
      <li class="short-line"></li>
      <li><button class="active" data-page="${active}">${active}</button></li>
      <li><button data-page="${active + 1}">${active + 1}</button></li>
      <li><button data-page="${active + 2}">${active + 2}</button></li>
      <li class="short-line"></li>
      <li><button data-page="${pages}">${
      pages > 9 ? pages : "0" + pages
    }</button></li>`;
  } else if (pages - active < 4 && pages > 4) {
    pagination = `
      <li><button data-page="1">01</button></li>
      <li class="line"></li>
      <li><button ${pages - 2 == active ? 'class="active"' : ""} data-page="${
      pages - 2
    }">${pages - 2}</button></li>
      <li><button ${pages - 1 == active ? 'class="active"' : ""} data-page="${
      pages - 1
    }">${pages - 1}</button></li>
      <li><button ${
        pages == active ? 'class="active"' : ""
      } data-page="${pages}">${pages}</button></li>`;
  }

  return `
  <div class="pagination">
    <ul class="pagination__pages">
      ${pagination}
    </ul>
    <div class="pagination__controls">
      ${
        active > 1
          ? `<button class="pagination__btns-prev" data-page="${
              active > 1 ? active - 1 : ""
            }"></button>`
          : ``
      }
      ${
        active != pages
          ? `<button class="pagination__btns-next" data-page="${
              active < pages ? active + 1 : ""
            }"></button>`
          : ``
      }
      
      
    </div>
  </div>`;
}

function displayLoader() {
  window.scrollTo(0, 0);
  $("#knowledge-posts").html(loader());
  $("#knowledge-pagination").html("");
}

function loader() {
  return `
  <div class="d-flex justify-content-center w-100 mb-6">
    <div class="loader"></div>
  </div>`;
}
}
